import React, { useState } from "react";
import trans, { isRTL } from "../../utils";
import Close from "../Helpers/CloseBtn/Close";
import Button from "../Helpers/Button/Button";
import { toast } from "react-toastify";
import { useCancelRequestMutation } from "../../Redux/service/Requests/Request";
import { Form, Modal } from "react-bootstrap";

export default function RequestCancelPopup({
	reqId,
	refetch,
	setCancelRequest,
}) {
	console.log("reqIdpopup", reqId);

	const [cancelRequest] = useCancelRequestMutation();
	const [reason, setReason] = useState("");

	const handleCancelRequest = async (id) => {
		try {
			await cancelRequest({ id, reason }).unwrap();
			setCancelRequest(null);
			setReason("");
			toast.success(trans("Service request cancellation request submitted successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			refetch();
		} catch (error) {
			toast.error(error?.data?.message || trans("Failed to submit cancellation request"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	return (
		<>
			<Modal show={!!reqId} centered dir={!isRTL ? "ltr" : "rtl"}>
				<Modal.Header>
					<div className="flex-between w-100">
						<Modal.Title>{trans("Request Cancel")}</Modal.Title>
						<Close
							style="close-32 close"
							img="Close"
							close={() => { setCancelRequest(null); setReason(""); }}
						/>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-3">
						{trans("Are you sure you want to request cancellation for this request")}
					</div>
					<Form.Group>
						<Form.Label>{trans("Cancellation Reason")} ({trans("Optional")})</Form.Label>
						<Form.Control
							as="textarea"
							rows={3}
							value={reason}
							onChange={(e) => setReason(e.target.value)}
							placeholder={trans("Enter reason for cancellation")}
						/>
					</Form.Group>
				</Modal.Body>
				<Modal.Footer>
					<Button
						text={trans("Request Cancel")}
						onClick={() => handleCancelRequest(reqId)}
						danger={true}
					/>
				</Modal.Footer>
			</Modal>
		</>
	);
}
